// apps/web/src/features/crm/leads/card/LeadCardBody.tsx
//
// Center zone of the card (#2247 FR-2, re-skinned #2315): tasks → CLOSING
// checklist → unified timeline. Each child now frames itself in a
// `SectionCard` (#2308 rhythm), so this is a thin composition column —
// reuses the existing lead sub-resource surfaces keyed by `leadId`
// (`LeadTasksSection`, `LeadEpisodeFeed` which renders the shared
// `JournalTimeline`); the checklist is data-guarded behind the CLOSING phase.
import { EngagementPhase } from '@magimp/shared';
import { LeadTasksSection, LeadEpisodeFeed } from '../activity/index.js';
import { LeadCardChecklist } from './LeadCardChecklist.js';

export interface LeadCardBodyProps {
  leadId: string;
  engagementId: string;
  phase: EngagementPhase;
  canManage: boolean;
  /** #2317: admin-or-assigned editability gate for the card's mutation controls. */
  canEditCard: boolean;
}

export function LeadCardBody({
  leadId,
  engagementId,
  phase,
  canManage,
  canEditCard,
}: LeadCardBodyProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, minHeight: 0 }}>
      <LeadTasksSection leadId={leadId} canEditCard={canEditCard} />
      <LeadCardChecklist
        leadId={leadId}
        engagementId={engagementId}
        phase={phase}
        canEditCard={canEditCard}
      />
      <LeadEpisodeFeed leadId={leadId} canManage={canManage} />
    </div>
  );
}
